import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';
import type { ServiceDto } from '@/services/serviceService';

interface ServiceState {
  currentService?: ServiceDto;
}

const initialState: ServiceState = {
  currentService: undefined,
};

export const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    setCurrentService: (state, action: PayloadAction<ServiceDto | undefined>) => {
      state.currentService = action.payload;
    },
    clearCurrentService: (state) => {
      state.currentService = undefined;
    },
  },
});

export const { setCurrentService, clearCurrentService } = serviceSlice.actions;

export const selectCurrentService = (state: RootState) => state.service.currentService;

export default serviceSlice.reducer;
